import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Logo from './Logo';
import './Nav.css';

const LINKS = [
  { to: '/#work', label: 'What we build' },
  { to: '/#process', label: 'Process' },
  { to: '/#privacy-first', label: 'Privacy' },
  { to: '/privacy', label: 'Policies', route: true },
];

function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <nav className={scrolled || open ? 'nav scrolled' : 'nav'}>
      <div className="wrap nav-in">
        <Link to="/" className="brand" aria-label="AppNexa home">
          <Logo />
          <span>AppNexa</span>
        </Link>

        <div className="nav-links">
          {LINKS.map((link) =>
            link.route ? (
              <NavLink key={link.to} to={link.to}>
                {link.label}
              </NavLink>
            ) : (
              <a key={link.to} href={link.to}>
                {link.label}
              </a>
            )
          )}
        </div>

        <div className="nav-cta">
          <Link className="btn sm" to="/contact">
            Get in touch
          </Link>
          <button
            className={open ? 'burger open' : 'burger'}
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
          >
            <span />
            <span />
          </button>
        </div>
      </div>

      <div className={open ? 'drawer open' : 'drawer'}>
        <div className="wrap drawer-in">
          {LINKS.map((link) =>
            link.route ? (
              <Link key={link.to} to={link.to} onClick={() => setOpen(false)}>
                {link.label}
              </Link>
            ) : (
              <a key={link.to} href={link.to} onClick={() => setOpen(false)}>
                {link.label}
              </a>
            )
          )}
          <Link to="/delete-account" onClick={() => setOpen(false)}>
            Delete your account
          </Link>
          <Link to="/contact" className="btn" onClick={() => setOpen(false)}>
            Get in touch
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
